<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getMaintenanceHistorys"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="workOrderExecutions" optionsLabel="shift" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Work Order Execution" id="filter-" size="sm" :model.sync="filter.workOrderExecutionnId" @input="getWorkOrderExecutions" @focus="getWorkOrderExecutions" />
					<app-input-textarea id="fieldset-trouble-report" label-cols-sm="4" label-cols-lg="3" label="Trouble Report" label-for="filter-trouble-report" size="sm" :model.sync="filter.troubleReportMultiple" />
					<app-input-textarea id="fieldset-analisa-dan-penyebab" label-cols-sm="4" label-cols-lg="3" label="Analisa dan Penyebab" label-for="filter-analisa-dan-penyebab" size="sm" :model.sync="filter.analisaDanPenyebabMultiple" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-textarea id="fieldset-tindakan" label-cols-sm="4" label-cols-lg="3" label="Tindakan" label-for="filter-tindakan" size="sm" :model.sync="filter.tindakanMultiple" />
					<app-input-combobox-autocomplete :options="picTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="PIC Type" id="filter-" size="sm" :model.sync="filter.picTypeId" @input="getPicTypes" @focus="getPicTypes" />
					<app-input-textbox id="fieldset-pic-name" label-cols-sm="4" label-cols-lg="3" label="Pic Name" label-for="filter-pic-name" size="sm" :model.sync="filter.picName" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getMaintenanceHistorys"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Maintenance History</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="true" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/maintenancehistory/MaintenanceHistory.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/maintenancehistory/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/maintenancehistory/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="true" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					
					<b-overlay v-if="isShowDeleteButton"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-maintenancehistory" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="maintenanceHistorys" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="maintenanceHistorys.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Work Order Execution" class="table-filter">
					<v-select append-to-body label="shift" :options="workOrderExecutions" :value="filter.workOrderExecutionnId" :reduce="item => item.id" v-model="filter.workOrderExecutionnId" :filterable="true" @input="getMaintenanceHistorysWithoutLoading" @search="getWorkOrderExecutions"></v-select>
				</b-th>
				<b-th stacked-heading="Trouble Report" class="table-filter">
					<b-form-input id="input-trouble-report-table" @input="getMaintenanceHistorysWithoutLoading" v-model="filter.troubleReport" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Analisa dan Penyebab" class="table-filter">
					<b-form-input id="input-analisa-dan-penyebab-table" @input="getMaintenanceHistorysWithoutLoading" v-model="filter.analisaDanPenyebab" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Tindakan" class="table-filter">
					<b-form-input id="input-tindakan-table" @input="getMaintenanceHistorysWithoutLoading" v-model="filter.tindakan" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="PIC Type" class="table-filter">
					<v-select append-to-body label="name" :options="picTypes" :value="filter.picTypeId" :reduce="item => item.id" v-model="filter.picTypeId" :filterable="true" @input="getMaintenanceHistorysWithoutLoading" @search="getPicTypes"></v-select>
				</b-th>
				<b-th stacked-heading="Pic Name" class="table-filter">
					<b-form-input id="input-pic-name-table" @input="getMaintenanceHistorysWithoutLoading" v-model="filter.picName" size="sm"></b-form-input>
				</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(troublereport)="row">

                <a @click="() => ( $router.push({ name: 'maintenancehistorydetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.troubleReport != null && row.item.troubleReport != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.troubleReport.slice(0, 30) + (row.item.troubleReport.length > 30 ? "..." : "" ) : row.item.troubleReport : "" }}
						</a>
            
					</template>

			<template v-slot:cell(workOrderExecutionn)="row">
				{{ row.item.workOrderExecutionn != null ? row.item.workOrderExecutionn.shift : "" }}
			</template>
				<template v-slot:cell(analisadanpenyebab)="row">
					<app-long-text  :id="'analisadanpenyebab-' + row.index" :text="row.item != null ? (row.item.analisaDanPenyebab != null && row.item.analisaDanPenyebab != '' ? row.item.analisaDanPenyebab : '') : ''" />
				</template>
				<template v-slot:cell(tindakan)="row">
					<app-long-text  :id="'tindakan-' + row.index" :text="row.item != null ? (row.item.tindakan != null && row.item.tindakan != '' ? row.item.tindakan : '') : ''" />
				</template>
			<template v-slot:cell(picType)="row">
				{{ row.item.picType != null ? row.item.picType.name : "" }}
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="isShowDeleteButton">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textarea id="fieldset-analisa-dan-penyebab" label-cols-lg="12"  label="Analisa dan Penyebab" label-for="input-analisa-dan-penyebab" size="sm" :model.sync="row.item.analisaDanPenyebab"   :isEditable="false" :isUpdatable="true" />
						<app-input-textarea id="fieldset-tindakan" label-cols-lg="12"  label="Tindakan" label-for="input-tindakan" size="sm" :model.sync="row.item.tindakan"   :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.picTypeId" label="PIC Type" :selected="row.item.picType != null ? row.item.picType.name : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-pic-name" label-cols-lg="12"  label="Pic Name" label-for="input-pic-name" size="sm" :model.sync="row.item.picName"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(maintenanceHistorysPaging != null ? maintenanceHistorysPaging.dataCount : 0)"
									:per-page="(maintenanceHistorysPaging != null ? maintenanceHistorysPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-maintenancehistory.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-maintenancehistory.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import MaintenanceHistory from '@/models/MaintenanceHistory/MaintenanceHistory';
import MaintenanceHistoryList from '@/models/MaintenanceHistory/MaintenanceHistoryList';
import MaintenanceHistoryFilter from '@/filters/MaintenanceHistory/MaintenanceHistoryFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import WorkOrderExecutionFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionFilter';
import WorkOrderExecution from '@/models/WorkOrderExecution/WorkOrderExecution';
import PicTypeFilter from '@/filters/PicType/PicTypeFilter';
import PicType from '@/models/PicType/PicType';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		MaintenanceHistory, 
		MaintenanceHistoryList, 
		MaintenanceHistoryFilter, 
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextarea,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"workOrderExecutionn": {}, "class" : "th-work-order-executionn first-child", "label" : "Work Order Execution", key: 'workOrderExecutionn', sortable: true}, 
				{"troubleReport": {}, "class" : "th-trouble-report", "label" : "Trouble Report", key: 'troubleReport', sortable: true}, 
				{"analisaDanPenyebab": {}, "class" : "th-analisa-dan-penyebab last-child", "label" : "Analisa dan Penyebab", key: 'analisaDanPenyebab', sortable: true}, 
				{"tindakan": {}, "class" : "th-tindakan d-stack-none", "label" : "Tindakan", key: 'tindakan', sortable: true}, 
				{"picType": {}, "class" : "th-pic-type d-stack-none", "label" : "PIC Type", key: 'picType', sortable: true}, 
				{"picName": {}, "class" : "th-pic-name d-stack-none", "label" : "Pic Name", key: 'picName', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			maintenanceHistorys: [],
			maintenanceHistorysPaging: {},
			workOrderExecutions : [],
			picTypes : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			
		}
	},	methods : {
		getMaintenanceHistorys : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			MaintenanceHistory.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.maintenanceHistorys = result.data
					this.maintenanceHistorysPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getMaintenanceHistorysWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			MaintenanceHistory.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.maintenanceHistorys = result.data
					this.maintenanceHistorysPaging = result
				}
			})
			.catch(error => {});
		},
		getWorkOrderExecutions : async function(input) {
			let filter = new WorkOrderExecutionFilter();
			if (input != undefined) {
				filter.shift = input;
			}
			awaitWorkOrderExecution.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutions = result.data
				}
			})
			.catch(error => {});
		},
		getPicTypes : async function(input) {
			let filter = new PicTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			awaitPicType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.picTypes = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new MaintenanceHistoryFilter();
			this.getMaintenanceHistorys();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getMaintenanceHistorys();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				MaintenanceHistory.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			MaintenanceHistory.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			MaintenanceHistory.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			MaintenanceHistory.deleteData(this, id).then(result => {
				if (result)
				{
					this.getMaintenanceHistorys();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				MaintenanceHistory.deleteMultipleData(this).then(result => {
					this.getMaintenanceHistorys();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableMaintenanceHistoryParent = document.getElementById('table-list-maintenancehistory').parentNode;
			tableMaintenanceHistoryParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableMaintenanceHistoryParent.scrollWidth - tableMaintenanceHistoryParent.offsetWidth) == Math.ceil(tableMaintenanceHistoryParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableMaintenanceHistoryParent = document.getElementById('table-list-maintenancehistory').parentNode;
			tableMaintenanceHistoryParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableMaintenanceHistoryParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new MaintenanceHistoryFilter();
		// this.getWorkOrderExecutions()
		// this.getPicTypes()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Maintenance History"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getMaintenanceHistorys();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getMaintenanceHistorys();
			}
		},
		sortDesc: {
			handler: function() {
				this.getMaintenanceHistorys();
			}
		},
		currentPage: {
			handler: function() {
				this.getMaintenanceHistorys();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getMaintenanceHistorys();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				MaintenanceHistory.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "maintenancehistoryindex") {
					this.getMaintenanceHistorysWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "maintenance_history").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
